import { render, staticRenderFns } from "./invoice-activity-table.vue?vue&type=template&id=71e72716&scoped=true"
import script from "./invoice-activity-table.vue?vue&type=script&lang=js"
export * from "./invoice-activity-table.vue?vue&type=script&lang=js"
import style0 from "./invoice-activity-table.vue?vue&type=style&index=0&id=71e72716&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e72716",
  null
  
)

export default component.exports